package com.arena_web.ui.localization

object AppStringsPT : AppStrings {

    // language selector
    override val headerProfileLanguage = "Idioma"
    override val headerProfileLanguageRecommended = "Recomendado"

    // common
    override val commonSeeAll = "Ver tudo"
    override val commonNo = "Não"
    override val commonYes = "Sim"
    override val commonConfirm = "Confirmar"
    override val commonSend = "Enviar"
    override val commonError = "Erro"
    override val commonOk = "OK"

    // chat
    override val chatMenuUnmute = "Ativar som"
    override val chatMenuMute = "Silenciar"
    override val chatMenuInviteMembers = "Convidar membros"
    override val chatMenuLeaveGroup = "Sair do grupo"
    override val chatMenuDeleteChat = "Excluir chat"
    override fun chatRemoveMemberTitle(name: String) = "Remover $name?"
    override fun chatRemoveMemberWarning(name: String) = "Remover $name do grupo? Esta ação não pode ser desfeita."
    override val chatRemoveMemberAction = "Remover"
    override val chatDefaultName = "Chat"
    override fun chatTypingOne(name: String) = "$name está digitando..."
    override fun chatTypingMany(count: Int) = "$count pessoas digitando..."
    override fun chatMembersCount(count: Int) = "$count membros"
    override fun chatMembersCountOnline(count: Int, online: Int) = "$count membros, $online online"
    override val chatOnline = "Online"
    override val chatOffline = "Offline"
    override val chatEditCommunityTitle = "Editar comunidade"
    override val chatCommunityNameLabel = "Nome da comunidade"
    override val chatCommunityNamePlaceholder = "Digite o nome da comunidade..."
    override val chatSaving = "Salvando..."
    override val chatMessageInputPlaceholder = "Digite uma mensagem..."
    override val chatInviteMembersTitle = "Convidar membros"
    override val chatSearchFriendsPlaceholder = "Buscar amigos..."
    override val chatNoFriendsToInvite = "Nenhum amigo para convidar"
    override val chatNoResults = "Nenhum resultado"
    override val chatInviting = "Convidando..."
    override val chatInvite = "Convidar"
    override fun chatInviteCount(count: Int) = "Convidar ($count)"
    override val chatPanelTitle = "Chat da Arena"
    override val chatSearchPlaceholder = "Buscar chat"
    override val chatFilterAll = "Todos"
    override val chatFilterDirect = "Diretas"
    override val chatFilterCommunity = "Comunidade"
    override val chatNoChatsFound = "Nenhum chat encontrado"
    override val chatNoConversationsYet = "Nenhuma conversa ainda"
    override val chatNewChatTitle = "Novo chat"
    override val chatTabDirectMessage = "Mensagem direta"
    override val chatTabCommunity = "Comunidade"
    override val chatSearchPeoplePlaceholder = "Busque pessoas que você segue..."
    override val chatNotFollowingAnyone = "Você ainda não segue ninguém"
    override val chatCreating = "Criando..."
    override val chatCreateCommunity = "Criar comunidade"
    override val chatSelectConversation = "Selecione uma conversa"
    override fun chatReplyTo(name: String) = "Responder a $name"
    override val chatUnknownSender = "Desconhecido"
    override val chatUploading = "Enviando..."
    override val chatEditingMessage = "Editando mensagem"
    override val chatSearchInChatPlaceholder = "Buscar no chat..."
    override fun chatSearchResultsFound(count: Int) = "$count encontrados"
    override val chatGroupInfoTitle = "Info do grupo"
    override val chatUserInfoTitle = "Info do usuário"
    override val chatDeleteChatAction = "Excluir chat"
    override val chatDeleteGroupAction = "Excluir grupo"
    override val chatLeaveGroupAction = "Sair do grupo"
    override val chatLastSeenRecently = "visto por último recentemente"
    override val chatNotificationsLabel = "Notificações"
    override val chatTabMembers = "Membros"
    override val chatTabMedia = "Mídia"
    override val chatTabFiles = "Arquivos"
    override val chatTabLinks = "Links"
    override val chatLoading = "Carregando..."
    override val chatNoMediaYet = "Nenhuma mídia ainda"
    override val chatNoFilesYet = "Nenhum arquivo ainda"
    override val chatUnknownFile = "Arquivo desconhecido"
    override val chatNoLinksYet = "Nenhum link ainda"
    override val chatNoMembers = "Sem membros"
    override val chatRoleOwner = "Dono"
    override val chatRoleAdmin = "Admin"
    override val chatEdited = "editada"
    override val chatFileFallback = "Arquivo"
    override val chatMenuReply = "Responder"
    override val chatMenuPin = "Fixar"
    override val chatEmptyTitle = "Nenhum chat ainda"
    override val chatEmptySubtitle = "Comece uma conversa para ver suas mensagens aqui."
    override val chatUnnamed = "Sem nome"
    override val chatNoMessagesYet = "Nenhuma mensagem ainda"
    override val chatRoomEmptyTitle = "Nenhuma mensagem ainda"
    override val chatRoomEmptySubtitle = "Diga oi para começar a conversa."
    override fun chatMembersHeader(count: Int) = "Membros ($count)"
    override val chatNoMediaSharedYet = "Nenhuma mídia compartilhada ainda"
    override val chatNoFilesSharedYet = "Nenhum arquivo compartilhado ainda"
    override val chatNoLinksSharedYet = "Nenhum link compartilhado ainda"

    // widget
    override val widgetDismiss = "Dispensar"
    override val widgetSomethingWentWrong = "Algo deu errado"
    override val widgetTryAgain = "Tente novamente"
    override val widgetCookieTitle = "Usamos cookies"
    override val widgetCookieMessage = "Este site usa cookies para garantir a melhor experiência para você."
    override val widgetCookieDecline = "Recusar"
    override val widgetCookieAccept = "Aceitar"
    override val widgetAddInterval = "Adicionar intervalo"
    override val widgetSendMessage = "Enviar mensagem"
    override val widgetPrevious = "Anterior"
    override val widgetStatusVip = "VIP"
    override val widgetStatusActive = "Ativo"
    override val widgetStatusDebtor = "Devedor"
    override val widgetStatusInactive = "Inativo"
    override val widgetUnpaid = "não pago"
    override val widgetStatusInProgress = "Em andamento"
    override val widgetStatusUpcoming = "Em breve"
    override val widgetStatusPending = "Pendente"
    override val widgetStatusCompleted = "Concluído"
    override fun widgetFieldLabel(number: String) = "Quadra $number"
    override val widgetYearly = "Anual"
    override val widgetAllFields = "Todas as quadras"
    override val widgetPreviousMonth = "Mês anterior"
    override val widgetNextMonth = "Próximo mês"
    override val widgetSortAscending = "Ordem crescente"
    override val widgetSortDescending = "Ordem decrescente"
    override val widgetChecked = "Marcado"

    // form
    override val formSelectPlaceholder = "Selecionar..."

    // common
    override val commonCancel = "Cancelar"
    override val commonSave = "Salvar"
    override val commonDelete = "Excluir"
    override val commonEdit = "Editar"
    override val commonNext = "Avançar"
    override val commonRetry = "Tentar novamente"
    override val commonSearch = "Buscar"

    // event
    override val eventMatchEndedTitle = "A PARTIDA TERMINOU"
    override val eventMatchEndedSubtitle = "Avalie os jogadores para atualizar os rankings pessoais deles."
    override val eventTabMatchInfo = "Info da partida"
    override val eventTabLineups = "Escalações"
    override val eventTabMedia = "Mídia"
    override val eventCreateTeam = "Criar time"
    override val eventCancelEventQuestion = "Cancelar evento?"
    override val eventDeleteEventQuestion = "Excluir evento?"
    override fun eventWillBeCancelled(eventTitle: String) = "\"$eventTitle\" será marcado como cancelado."
    override fun eventWillBeDeleted(eventTitle: String) = "\"$eventTitle\" será excluído permanentemente."
    override val eventCancelNoticeParticipants = "Os outros participantes serão notificados. O chat e o histórico continuam disponíveis."
    override val eventDeleteNoticeMedia = "A imagem do evento e o chat também serão removidos."
    override val eventKeepEvent = "Manter evento"
    override val eventCancelling = "Cancelando..."
    override val eventDeleting = "Excluindo..."
    override val eventCancelEvent = "Cancelar evento"
    override val eventMatchPerformanceTitle = "Desempenho na partida"
    override val eventProPlusLabel = "Pro⁺"
    override val eventStatLabel = "Estatística"
    override val eventProPlusStatDescription = "Precisão de chutes, passes completados e posse de bola em detalhes."
    override val eventLoadingMedia = "Carregando mídia..."
    override val eventDeleteMediaQuestion = "Excluir mídia?"
    override val eventDeleteMediaMessage = "Este arquivo será removido do evento para todos."
    override val eventNoMediaYet = "Nenhuma mídia ainda"
    override val eventNoMediaDescription = "Fotos e vídeos desta partida vão aparecer aqui."
    override val eventInviteTeamTitle = "Convidar time"
    override val eventSearchTeamsLabel = "Buscar times"
    override val eventSearchTeamsPlaceholder = "Digite o nome do time..."
    override val eventSearching = "Buscando..."
    override val eventNoTeamsFound = "Nenhum time encontrado"
    override fun eventTeamRating(rating: String) = "Avaliação $rating"
    override fun eventTeamMembersCount(count: Int) = "$count membros"
    override val eventInviteStatusAccepted = "Aceito"
    override val eventInviteStatusDeclined = "Recusado"
    override val eventInviteStatusInvited = "Convidado"
    override val eventInvite = "Convidar"
    override val eventStartEventQuestion = "Iniciar evento?"
    override fun eventWillGoLive(eventTitle: String) = "\"$eventTitle\" vai entrar ao vivo."
    override val eventStartNotice = "As inscrições serão encerradas e a partida vai começar."
    override fun eventPendingRequestOne(count: Int) = "$count solicitação pendente"
    override fun eventPendingRequestsMany(count: Int) = "$count solicitações pendentes"
    override val eventPendingRequestsSubtitle = "Esses jogadores pediram para entrar, mas ainda não foram aprovados."
    override fun eventPlayersWithoutTeamOne(count: Int) = "$count jogador sem time"
    override fun eventPlayersWithoutTeamMany(count: Int) = "$count jogadores sem time"
    override val eventTeamlessSubtitle = "Eles estão confirmados, mas não foram atribuídos a nenhum time."
    override val eventStarting = "Iniciando..."
    override val eventStartAnyway = "Iniciar mesmo assim"
    override val eventMonthJanuary = "Janeiro"
    override val eventMonthFebruary = "Fevereiro"
    override val eventMonthMarch = "Março"
    override val eventMonthApril = "Abril"
    override val eventMonthMay = "Maio"
    override val eventMonthJune = "Junho"
    override val eventMonthJuly = "Julho"
    override val eventMonthAugust = "Agosto"
    override val eventMonthSeptember = "Setembro"
    override val eventMonthOctober = "Outubro"
    override val eventMonthNovember = "Novembro"
    override val eventMonthDecember = "Dezembro"
    override val eventVs = "vs"
    override val eventTeamsLabel = "times"
    override val eventPlayersLabel = "jogadores"
    override val eventProBadge = "PRO"
    override val eventCompletedBadge = "Concluído"
    override val eventLeadersEmptyWinGame = "Vença um jogo para subir no ranking."
    override val eventLeadersEmptyFirstScore = "Seja o primeiro a marcar e lidere o ranking."
    override val eventLeadersEmptyTakeSet = "Ganhe um set para ficar com o primeiro lugar."
    override val eventLeadersEmptyFirstAssist = "Seja o primeiro a dar um passe decisivo."
    override fun eventTopStat(name: String) = "Top $name"
    override val eventPlayerFallback = "Jogador"
    override val eventCreateTeamSubtitle = "Monte seu time para a partida"
    override val eventTeamNameLabel = "Nome do time"
    override val eventTeamNameRequired = "O nome do time é obrigatório"
    override val eventTeamColorLabel = "Cor do time"
    override val eventTeamColorSubtitle = "Escolha a cor do seu time"
    override val eventTeamNamePlaceholder = "Digite o nome do time..."
    override val eventChatTitle = "Chat"
    override val eventChatLive = "Live"
    override val eventChatPlayersLabel = "Jogadores"
    override val eventChatWaitingApproval = "Aguardando aprovação"
    override val eventChatConfirmingSpot = "Confirmando sua vaga"
    override val eventChatLocked = "O chat está bloqueado"
    override val eventChatWaitingApprovalSubtitle = "Quando o admin confirmar sua solicitação, você poderá conversar com o time."
    override val eventChatConfirmingSpotSubtitle = "Sua solicitação está sendo processada. O chat desbloqueia assim que você entrar."
    override val eventChatPrivateSubtitle = "Este é um evento privado. Peça para entrar e aguarde a aprovação do admin."
    override val eventChatLockedSubtitle = "Você precisa entrar nesta partida para ver a conversa e falar com outros jogadores."
    override val eventJoinEvent = "Entrar no evento"
    override val eventChatNoMessages = "Nenhuma mensagem ainda"
    override val eventChatNoMessagesSubtitle = "Comece a conversa com o seu time."
    override val eventTeamSectionTitle = "Time"
    override val eventDeleteTeam = "Excluir time"
    override val eventViewProfile = "Ver perfil"
    override val eventRemoveAdmin = "Remover admin"
    override val eventMakeAdmin = "Tornar admin"
    override val eventRemoveFromTeam = "Remover do time"
    override val eventRemoveFromEvent = "Remover do evento"
    override fun eventFormatVs(format: Int) = "$format vs $format"
    override fun eventTeamsCount(count: Int) = "$count times"
    override fun eventPlayersOfMax(joined: Int, max: Int) = "$joined / $max jogadores"
    override fun eventPlayersCount(count: Int) = "$count jogadores"
    override val eventStatusLive = "Live"
    override val eventLeave = "Sair"
    override val eventStart = "Iniciar"
    override val eventJoin = "Entrar"
    override val eventStatusPending = "Pendente"
    override val eventStatusCanceled = "Cancelado"
    override val eventPendingApprovalBadge = "Aguardando aprovação"
    override val eventRatePerformanceTitle = "Avaliar desempenho"
    override val eventRateVoteCounts = "Seu voto conta!"
    override val eventCommunityRating = "Avaliação da comunidade"
    override val eventSubmitRating = "Enviar avaliação"
    override val eventSubmitting = "Enviando..."
    override val eventAddMediaTitle = "Adicionar mídia"
    override val eventUploadMedia = "Enviar mídia"
    override val eventDropMediaHere = "Solte sua foto e vídeo aqui"
    override val eventMaxFileSize = "máx. 30 MB"
    override val eventSelectedLabel = "Selecionados"
    override val eventClearAll = "Limpar tudo"
    override val eventAddToTeam = "Adicionar ao time"
    override val eventMakeSubstitution = "Fazer substituição"
    override val eventViewProfileSheet = "Ver perfil"
    override fun eventSwapWith(name: String) = "Substituir $name por"
    override val eventEndMatch = "Encerrar partida"
    override val eventReset = "Zerar"
    override val eventLeadersEmptyWinGameShort = "Vença um jogo para subir no ranking"
    override val eventLeadersEmptyScoreFirst = "Marque primeiro e lidere o ranking"
    override val eventLeadersEmptyTakeSetShort = "Ganhe um set para ficar com o primeiro lugar"
    override val eventLeadersEmptyWinningAssist = "Dê a assistência da vitória"
    override val eventRatePlayersSubtitle = "Avalie os jogadores para atualizar o Top Rankings"
    override val eventGenericError = "Algo deu errado"
    override val eventDeleteTeamQuestion = "Excluir time?"
    override fun eventDeleteTeamMessage(teamName: String) = "\"$teamName\" será removido deste evento. Os jogadores atribuídos a ele ficarão sem time."
    override val eventPlayersTitle = "Jogadores"
    override fun eventApprovedCount(confirmed: Int, total: Int) = "($confirmed/$total aprovados)"
    override val eventAwaitingPlayers = "Aguardando jogadores"
    override val eventAwaitingPlayersSubtitle = "Entre no evento agora para começar a montar os times."
    override val eventAssignToTeam = "Atribuir a um time"
    override val eventFormatLabel = "Formato:"
    override val eventProLabel = "Pro"
    override val eventTimeline = "Linha do tempo"
    override val eventFormatAuto = "Auto"
    override val eventCoach = "Técnico"
    override val eventSaving = "Salvando..."
    override val eventCreating = "Criando..."
    override val eventSaveChanges = "Salvar alterações"
    override val eventCreateEvent = "Criar evento"
    override val eventEditEventTitle = "Editar evento"
    override val eventErrorTitleRequired = "O título é obrigatório"
    override val eventErrorSportRequired = "O esporte é obrigatório"
    override val eventErrorSportNameRequired = "O nome do esporte é obrigatório"
    override val eventErrorFormatRequiredPro = "O formato é obrigatório para eventos Pro"
    override val eventErrorStartTimeRequired = "O horário de início é obrigatório"
    override val eventErrorEndTimeRequired = "O horário de término é obrigatório"
    override val eventErrorEndAfterStart = "O horário de término deve ser depois do início"
    override val eventErrorStartInPast = "O horário de início não pode estar no passado"
    override val eventErrorSelectAddress = "Selecione um endereço"
    override val eventErrorAddressCity = "Escolha um endereço válido que inclua uma cidade"
    override val eventErrorCoverRequired = "A foto de capa é obrigatória"
    override val eventErrorSignInEdit = "Faça login para editar eventos"
    override val eventErrorSignInCreate = "Faça login para criar eventos"
    override val eventErrorUploadImage = "Falha ao enviar a imagem"
    override val eventErrorSaveChanges = "Falha ao salvar as alterações"
    override val eventErrorCreateEvent = "Falha ao criar o evento"
    override val eventAddressLabel = "Endereço"
    override val eventAddressPlaceholder = "Buscar endereço..."
    override val eventTitleLabel = "Título"
    override val eventTitlePlaceholder = "ex.: Partida de futebol de domingo"
    override val eventSportNameLabel = "Nome do esporte"
    override val eventSportNamePlaceholder = "Digite o nome do esporte"
    override val eventMaxPlayersLabel = "Máx. de jogadores"
    override val eventMaxPlayersPlaceholder = "ex.: 20"
    override val eventDateLabel = "Data"
    override val eventTimeFromLabel = "De"
    override val eventTimeToLabel = "Até"
    override val eventChooseOnMap = "Escolher no mapa"
    override val eventConfirmLocation = "Confirmar local"
    override val eventAddPhoto = "Adicionar foto"
    override val eventSportLabel = "Esporte"
    override val eventLoading = "Carregando..."
    override val eventSelectSportPlaceholder = "Selecione o esporte"
    override val eventCommunityLabel = "Comunidade"
    override val eventCommunityNone = "Nenhuma (público)"
    override val eventUnnamedGroup = "Grupo sem nome"
    override val eventFormatFieldLabel = "Formato"
    override val eventSelectPlaceholder = "Selecionar"
    override val eventCostLabel = "Custo"
    override val eventPrivateLabel = "Privado"
    override val eventPrivateInfoDescription = "Gerencie seu time aprovando manualmente as solicitações de entrada ou removendo participantes."

    // wallet
    override val walletTopUpTitle = "Recarregar carteira"
    override val walletSelectAmount = "Selecione o valor"
    override val walletOr = "ou"
    override val walletCustomAmount = "Valor personalizado"
    override val walletEnterAmountPlaceholder = "Digite o valor"
    override val walletProcessing = "Processando…"
    override val walletTopUpAction = "Recarregar"

    // nav
    override val navDashboard = "Painel"
    override val navClients = "Clientes"
    override val navChat = "Chat"
    override val navSchedule = "Agenda"
    override val navClubSettings = "Configurações do clube"
    override val navArena = "Arena"
    override val navFeed = "Feed"
    override val navPeople = "Pessoas"
    override val navProfile = "Perfil"
    override val navStatistic = "Estatísticas"
    override val navTeam = "Time"
    override val navMedia = "Mídia"
    override val navWeek = "Semana"
    override val navMonth = "Mês"
    override val navYear = "Ano"

    // modal
    override val modalDecline = "Recusar"
    override val modalCompleteSession = "Concluir sessão"
    override val modalTimeAlt = "Horário"
    override val modalPriceAlt = "Preço"
    override val modalBookings = "Reservas"
    override val modalTotalSpent = "Total gasto"
    override val modalSendMessage = "Enviar mensagem"
    override val modalAddNote = "Adicionar nota"
    override val modalAdminNotes = "Notas do admin"
    override val modalAdminNotesPrivacy = "Privado - visível apenas para admins"
    override val modalWriteNotePlaceholder = "Escreva uma nota..."
    override val modalAdd = "Adicionar"
    override val modalBookingHistory = "Histórico de reservas"
    override val modalNoBookingsYet = "Nenhuma reserva ainda"
    override val modalFieldFallback = "Quadra"
    override val modalStatusConfirmed = "Confirmada"
    override val modalStatusPending = "Pendente"
    override val modalStatusCompleted = "Concluída"
    override val modalStatusCancelled = "Cancelada"
    override val modalPaid = "Pago"
    override val modalUnpaid = "Não pago"

    // feed
    override val feedClubBadge = "Clube"
    override fun feedAddAllPhotos(count: Int) = "Adicionar as $count foto(s)"
    override val feedUploadFailed = "Falha no envio"
    override val feedCreatePostFailed = "Falha ao criar o post"
    override val feedCreatePostTitle = "Criar post"
    override val feedChooseLayoutSubtitle = "Escolha um layout para o seu post"
    override val feedFileTooLarge = "Arquivo muito grande (máx. 50 MB)"
    override val feedChooseLayout = "Escolha um layout"
    override val feedCreating = "Criando..."
    override val feedAddPhoto = "Adicionar foto"
    override val feedCityLabel = "Cidade"
    override val feedEnterCityPlaceholder = "Digite o nome da cidade..."
    override val feedPostContentLabel = "Conteúdo do post"
    override val feedPostContentPlaceholder = "Escreva algo sobre este post..."
    override val feedOptional = "(Opcional)"
    override val feedPickPhotoFirst = "Escolha uma foto primeiro"
    override val feedCreateStoryFailed = "Falha ao criar o story"
    override val feedCreateStoriesTitle = "Criar stories"
    override val feedCreateStoriesSubtitle = "Crie e compartilhe seus momentos"
    override val feedFileTooLargeStory = "Arquivo muito grande (máx. 30 MB)"
    override val feedDropContentHere = "Solte seu conteúdo aqui"
    override val feedMaxStorySize = " máx. 30 MB"
    override val feedFollowingSection = "Seguindo"
    override val feedFollowersSection = "Seguidores"
    override val feedSearching = "Buscando…"
    override val feedNoResults = "Nenhum resultado"
    override val feedLoadingMore = "Carregando mais…"
    override val feedThisUser = "este usuário"
    override fun feedUnfollowTitle(name: String) = "Deixar de seguir $name?"
    override val feedUnfollowSubtitle = "Você pode voltar a seguir quando quiser."
    override val feedUnfollow = "Deixar de seguir"
    override fun feedRemoveTitle(name: String) = "Remover $name?"
    override val feedRemoveSubtitle = "A pessoa não será notificada, mas não verá mais seus posts."
    override val feedRemove = "Remover"
    override val feedFollow = "Seguir"
    override val feedDeleted = "Excluído"
    override val feedNotFollowingTitle = "Você ainda não segue ninguém"
    override val feedNotFollowingBody = "Siga jogadores para ver os posts, melhores momentos e stories deles no seu feed."
    override val feedNoFollowersTitle = "Nenhum seguidor ainda"
    override val feedNoFollowersBody = "Compartilhe seus posts e stories de partidas para ser notado pela comunidade."
    override val feedDiscoverPlayers = "Descobrir jogadores"

    // dropdown
    override val dropdownAllCities = "Todas as cidades"
    override val dropdownSelectedAlt = "Selecionado"

    // page
    override val pageScheduleTitle = "Agenda"
    override val pageScheduleComingSoon = "A visualização da agenda chega em breve"
    override val pageEventsSeoTitle = "Eventos esportivos"
    override val pageEventsSeoDescription = "Explore e participe de eventos esportivos perto de você — futebol, tênis, basquete, padel e mais. Crie seu próprio jogo e convide jogadores na Arena."
    override val pageEventsTitle = "Eventos"
    override val pageCreateEvent = "Criar evento"
    override val pageNoEventsYet = "Nenhum evento ainda"
    override val pageNotFoundTitle = "Ops, página não encontrada"
    override val pageNotFoundBody = "Verifique se o endereço da página está correto ou volte para a arena principal."
    override val pageBackToArena = "Voltar para a Arena"
    override val pageChatTitle = "Chat"
    override val pageLoading = "Carregando..."
    override val pageSomethingWentWrong = "Algo deu errado"
    override fun pageUnfollowTitle(name: String) = "Deixar de seguir $name"
    override val pageRemoveFollowerTitle = "Remover seguidor?"
    override fun pageRemoveFollowerSubtitle(name: String) = "Não vamos notificar $name sobre essa mudança."
    override val pageFeedTitle = "Feed"
    override val pageFeedSeoDescription = "Veja o que a comunidade esportiva da Arena anda fazendo — resultados de partidas, melhores momentos e momentos compartilhados por jogadores perto de você."
    override val pageNoPostsYet = "Nenhum post ainda"
    override val pageLoadingMore = "Carregando mais..."
    override val pagePeopleSeoTitle = "Encontre jogadores"
    override val pagePeopleSeoDescription = "Descubra atletas perto de você, dê match com jogadores do seu nível e monte um time para o seu próximo jogo na Arena."
    override val pagePeopleTitle = "Pessoas"
    override val pageSquadUpTitle = "Monte seu time"
    override val pageSquadUpSubtitle = "Encontre parceiros, conecte-se com jogadores e comece o jogo."
    override val pagePeopleLoadFailed = "Não foi possível carregar as pessoas"
    override val pagePeopleCaughtUpTitle = "Você está em dia por enquanto"
    override val pagePeopleCaughtUpSubtitle = "Volte mais tarde para ver mais jogadores."
    override val pageRefresh = "Atualizar"
    override val pageClientsTitle = "Clientes"
    override fun pageClientsTotal(total: Int) = "$total clientes no total"
    override val pageActiveClients = "Clientes ativos"
    override val pageTotalBookings = "Total de reservas"
    override val pageTotalRevenue = "Receita total"
    override val pageStatusVip = "VIP"
    override val pageStatusActive = "Ativo"
    override val pageStatusDebtor = "Devedor"
    override val pageStatusAll = "Todos os status"
    override val pageStatusInactive = "Inativo"
    override val pageAddNewClient = "Adicionar cliente"
    override val pageColName = "Nome"
    override val pageColRevenue = "Receita"
    override val pageColStatus = "Status"
    override val pageColLastVisit = "Última visita"
    override val pageColActions = "Ações"
    override val pageUnpaidSuffix = "não pago"
    override val pagePrevious = "Anterior"
    override val pagePageLabel = "Página"
    override val pageOfLabel = "de"
    override val pageBackToEvents = "Voltar para eventos"
    override val pageResetTimerTitle = "Zerar o relógio?"
    override val pageResetTimerMessage = "O relógio da partida volta para 00:00. As estatísticas registradas são mantidas."
    override val pageResetTimerConfirm = "Zerar"
    override val pageResetting = "Zerando..."
    override val pageEndMatchTitle = "Encerrar partida?"
    override val pageEndMatchMessage = "O evento será marcado como concluído e os placares serão travados."
    override val pageEndMatchConfirm = "Encerrar partida"
    override val pageEnding = "Encerrando..."
    override val pageAddMedia = "Adicionar mídia"
    override val pageBook = "Reservar"
    override val pageCourtRules = "Regras da quadra"
    override val pageNoCourtRules = "Nenhuma regra de quadra especificada."
    override val pageLeaveReview = "Deixar uma avaliação"
    override val pageNoReviewsYet = "Nenhuma avaliação ainda."
    override val pageSportFootball = "Futebol"
    override val pageSportBasketball = "Basquete"
    override val pageSportTennis = "Tênis"
    override val pageSportPadel = "Padel"
    override val pageClubFallback = "Clube"
    override fun pageReviewExperienceTitle(sportName: String) = "Como foi sua experiência de $sportName?"
    override val pageWriteReviewPlaceholder = "Escreva sua avaliação..."
    override val pagePosting = "Publicando..."
    override val pagePostReview = "Publicar avaliação"
    override val pageLoadMore = "Carregar mais"
    override val pageArenaSeoTitle = "Arena"
    override val pageArenaSeoDescription = "Sua carreira esportiva em um só lugar — estatísticas, avaliações e conquistas no futebol, tênis, basquete e mais na Arena."
    override val pageEventsTab = "Eventos"
    override val pageClubsTab = "Clubes"
    override val pageFilterLocation = "Local"
    override val pageUnnamedCommunity = "Sem nome"
    override val pageFilterCommunity = "Comunidade"
    override val pageFilterAll = "Todos"
    override val pageFilterCalendar = "Calendário"
    override val pageAddEvent = "Adicionar evento"
    override val pageAddClub = "Adicionar clube"
    override val pageMap = "Mapa"
    override val pageOwnTheArena = "DOMINE A ARENA"
    override val pageArenaBannerSubtitle = "Sua arena espera por você. Reserve na hora — jogue com confiança."
    override val pageLoadingMoreEvents = "Carregando mais eventos..."
    override val pageLoadingMoreClubs = "Carregando mais clubes..."
    override val pageNoClubsYet = "Nenhum clube ainda"
    override val pageClubsWillAppear = "Os clubes vão aparecer aqui"
    override val pageEventsMapTitle = "Mapa de eventos"
    override val pageClubsMapTitle = "Mapa de clubes"
    override val pageDeleteClub = "Excluir clube"
    override val pageAddBanner = "Adicionar banner"
    override val pageRulePlaceholder = "ex.: Roupa esportiva obrigatória"
    override val pageAddRule = "Adicionar regra"
    override val pageEditServices = "Editar serviços"
    override val pageManageServices = "Gerenciar serviços"
    override val pageAmenityParking = "Estacionamento"
    override val pageAmenityCafe = "Café"
    override val pageAmenityWifi = "WiFi"
    override val pageAmenityReception = "Recepção"
    override val pageAmenityShower = "Chuveiro"
    override val pageAmenityFirstAid = "Primeiros socorros"
    override val pageReviewsLabel = "Avaliações:"
    override val pageAvgRatingLabel = "Aval. média:"
    override val pageReviewsPlaceholderNote = "As avaliações vão aparecer aqui quando os usuários deixarem feedback."
    override val pageClubComposePrompt = "O que está acontecendo no seu clube?"
    override val pageClubNoPostsHint = "Compartilhe uma foto e um pensamento rápido para manter o clube ativo."
    override val pageComposePostTitle = "Escrever post"
    override val pagePostContentPlaceholder = "Conteúdo do post..."
    override fun pageAddImageSlot(slot: Int) = "Adicionar imagem $slot"
    override val pagePostAction = "Publicar"
    override val pageEditClubInfo = "Editar info do clube"
    override val pageClubNameLabel = "Nome do clube"
    override val pageAddressLabel = "Endereço"
    override val pageSearchAddressPlaceholder = "Buscar endereço"
    override val pageSaveChanges = "Salvar alterações"

    // account
    override val accountRequiredTitle = "Conta necessária"
    override val accountRequiredDescription = "Este recurso é só para jogadores registrados. Faça login com Google ou Apple para continuar."
    override val accountRequiredTermsPrefix = "Ao continuar, você concorda com nossos "
    override val accountRequiredTerms = "Termos"
    override val accountRequiredPrivacy = "Privacidade"

    // avatar
    override val avatarGenTitle = "Avatar de IA"
    override val avatarGenErrorFileType = "Apenas arquivos JPEG, PNG e WebP são permitidos"
    override val avatarGenErrorFileSize = "O arquivo deve ter menos de 30 MB"
    override val avatarGenGenerating = "Gerando…"
    override val avatarGenGenerate = "Gerar"
    override fun avatarGenGenerateWithPrice(price: String) = "Gerar · $price"
    override val avatarGenGeneratedLook = "Visual gerado"
    override val avatarGenDropPhotoHere = "Solte sua foto aqui"
    override val avatarGenMaxFileSize = "máx. 30 MB"
    override val avatarGenReadyToGenerate = "Pronto para gerar"
    override val avatarGenCustomPrompt = "Prompt personalizado"
    override val avatarGenPromptPlaceholder = "Adicione detalhes para definir o estilo ..."
    override val avatarGenInfoDefaultBehavior = "Por padrão, a IA recorta você da foto e coloca você no card."
    override val avatarGenInfoPromptIntro = "No prompt você também pode pedir para:"
    override val avatarGenInfoBulletZoom = "Aproximar ou afastar a figura"
    override val avatarGenInfoBulletObject = "Adicionar ou remover um objeto (ex.: óculos de sol, camisa, bola, boné)"
    override val avatarGenOptionalBadge = "(Opcional)"

    // card
    override val cardLifeTitle = "Dê vida ao seu card"
    override val cardLifeSubtitle = "Crie sua identidade visual"
    override val cardLifeMyStyles = "Meus estilos"
    override val cardLifeSelectToGenerate = "Selecione para gerar"
    override val cardLifeActiveCards = "Cards de perfil ativos"
    override val cardLifeDragToReorder = "Arraste para reordenar"
    override val cardLifeNoTemplates = "Nenhum modelo de card ainda. Garanta um na loja de cards."
    override val cardLifeCreatePhoto = "Criar foto"
    override val cardLifeDeleteCardTitle = "Excluir card?"
    override val cardLifeDeleteCardMessage = "Isso remove o card da sua galeria. O modelo continua nos seus estilos."

    // wallet
    override val walletTitle = "Minha carteira"
    override val walletCredits = "Créditos"
    override val walletSignInToBuy = "Faça login para comprar créditos."
    override fun walletCreditsAdded(amount: Int) = "$amount créditos adicionados à sua carteira."
    override val walletPurchaseFailed = "A compra falhou. Tente novamente."
    override fun walletBuyFor(price: String) = "Comprar por $price"
    override val walletBackToPackages = "Voltar aos pacotes"
    override val walletSelectedPack = "Pacote selecionado"
    override fun walletOneTimePurchase(currency: String) = "$currency · Compra única"
    override val walletCurrentBalance = "Saldo atual"
    override val walletNewBalance = "Novo saldo"
    override val walletSecuredNote = "Seguro · Sem cobranças recorrentes"
    override val walletPaymentMethod = "Método de pagamento"
    override val walletOrPayWithCard = "Ou pague com cartão"
    override val walletCardNumber = "Número do cartão"
    override val walletExpiryDate = "Data de validade"
    override val walletCvc = "CVC"
    override fun walletConfirmAndPay(price: String) = "Confirmar e pagar €$price"

    // complete
    override val completeProfileTitle = "Complete seu perfil para começar a deslizar"
    override val completeProfileDescription = "Complete seu perfil para ver jogadores que combinam com seu nível e interesses."
    override val completeProfileMaybeLater = "Talvez depois"
    override val completeProfileAction = "Completar perfil"

    // preference
    override val preferenceDetailsTitle = "Detalhes de preferências"

    // follow
    override val followListFollowers = "Seguidores"
    override val followListFollowing = "Seguindo"
    override val followListNoResults = "Nenhum resultado"
    override val followListNoFollowersYet = "Nenhum seguidor ainda"
    override val followListNotFollowingAnyoneYet = "Você ainda não segue ninguém"
    override val followListUnfollow = "Deixar de seguir"
    override val followListFollow = "Seguir"
    override val followListRemove = "Remover"
    override val followListDeleted = "Excluído"

    // top
    override val topUpTitle = "Recarregue sua carteira"
    override fun topUpNeedMessage(required: String, action: String, balance: String) = "Você precisa de $required para $action, mas sua carteira tem $balance."
    override val topUpChooseAmount = "Escolha o valor"
    override val topUpOr = "ou"
    override val topUpCustomAmount = "Valor personalizado"
    override val topUpEnterAmountPlaceholder = "Digite o valor"
    override val topUpAction = "Recarregar"
    override val topUpFailed = "A recarga falhou"

    // interactions
    override val interactionsTitle = "Interações"
    override fun interactionsSubtitle(newLikes: Int, matches: Int) = "$newLikes novas curtidas · $matches matches"
    override val interactionsNewLikes = "Novas curtidas"
    override val interactionsNoNewLikesTitle = "Nenhuma curtida nova ainda"
    override val interactionsNoNewLikesMessage = "Quando alguém der um Sim em você, vai aparecer aqui."
    override val interactionsMatches = "Matches"
    override val interactionsNoMatchesTitle = "Nenhum match ainda"
    override val interactionsNoMatchesMessage = "Dê um Sim em alguém que já curtiu você para fechar um match."

    // match
    override val matchItsWord = "Deu"
    override val matchWord = "MATCH!"
    override val matchSubtitle = "Hora de se conectar e planejar o jogo."
    override val matchKeepSwiping = "Continuar deslizando"
    override val matchGoToProfile = "Ir para o perfil"
    override val matchYouFallback = "Você"

    // purchase
    override val purchaseCardTitle = "Quer este card?"
    override val purchaseCardBuying = "Comprando…"
    override val purchaseCardBuyNow = "Comprar agora"

    // post
    override val postCommentsLike = "Curtir"
    override val postCommentsOneLike = "1 curtida"
    override fun postCommentsLikes(count: Int) = "$count curtidas"
    override val postCommentsInputPlaceholder = "Digite uma mensagem…"

    // story
    override fun storySeenBy(count: Int) = "Visto por $count"

    // support
    override val supportTitle = "Falar com o suporte"
    override val supportIntro = "Conte para a gente o que deu errado ou com o que você precisa de ajuda — respondemos por e-mail."
    override val supportEmailLabel = "Seu e-mail"
    override val supportMessageLabel = "Mensagem"
    override val supportMessagePlaceholder = "Descreva seu problema…"
    override val supportErrorInvalidEmail = "Digite um e-mail válido."
    override val supportErrorEmptyMessage = "Escreva uma mensagem."
    override val supportErrorGeneric = "Algo deu errado. Tente novamente."
    override val supportSending = "Enviando…"
    override val supportSendMessage = "Enviar mensagem"
    override val supportSentTitle = "Mensagem enviada!"
    override val supportSentMessage = "Obrigado pelo contato — vamos responder no seu e-mail em breve."

    // person
    override val personDetailTabAbout = "Sobre"
    override val personDetailTabPosts = "Posts"
    override val personDetailTabAchievement = "Conquistas"
    override val personDetailAchievementsComingSoon = "Conquistas em breve."
    override val personDetailFollowing = "Seguindo"
    override val personDetailFollowers = "Seguidores"
    override val personDetailSportLabel = "Esporte:"
    override val personDetailActivityLabel = "Atividade:"
    override val personDetailLifestyleLabel = "Estilo de vida:"
    override val personDetailNoPostsTitle = "Nenhum post ainda"
    override val personDetailNoPostsMessage = "Este jogador ainda não postou nada."

    // common
    override val commonClose = "Fechar"
    override val commonDone = "Pronto"
    override val commonLoading = "Carregando…"
    override val commonBack = "Voltar"
    override val commonSkip = "Pular"

    // profile
    override val profileCardShopLoading = "Carregando..."
    override val profileCardShopEmpty = "Nenhum card disponível"
    override val profileCardShopBuy = "Comprar"
    override val profileCardShopFree = "Grátis"
    override val profileFormationReservePlate = "Res"
    override val profileFormationCoach = "Técnico"
    override val profileMediaEmpty = "Nenhuma mídia ainda"
    override val profileMediaImageAlt = "mídia"
    override val profileNewsPrompt = "No que você está pensando?"
    override val profileNewsLoading = "Carregando..."
    override val profileNewsLoginRequired = "Faça login para ver seus posts"
    override val profileNewsEmpty = "Nenhum post ainda. Compartilhe algo!"
    override val profileNewsPlaceholder = "Escreva algo..."
    override val profileNewsPosting = "Publicando..."
    override val profileNewsPost = "Publicar"
    override val profileRadarTitle = "Radar"
    override val profileRecentMatchesTitle = "Eventos recentes"
    override val profileRecentMatchesEmptyTitle = "Nenhum evento agendado ainda"
    override val profileRecentMatchesEmptyHint = "Escolha um evento e entre na ação!"
    override fun profileRecentMatchesSportPro(sport: String) = "$sport · Pro+"
    override val profileRecentMatchesTeamA = "Time A"
    override val profileRecentMatchesTeamB = "Time B"
    override fun profileRecentMatchesPeopleCount(count: Int) = "$count pessoas"
    override val profileRecentMatchesWin = "Vitória"
    override val profileRecentMatchesLoss = "Derrota"
    override val profileRecentMatchesDraw = "Empate"
    override val profileRecentMatchesSportFallback = "Esporte"
    override val profileRecentMatchesProPlus = "Pro+"
    override fun profileRecentMatchesFormat(format: Int) = "Formato $format X $format"
    override fun profileRecentMatchesMembers(count: Int) = "$count membros"
    override val profileShortcutStatistic = "Estatísticas"
    override val profileShortcutMedia = "Mídia"
    override val profileStatsChartsGoals = "Gols"
    override val profileStatsChartsAssists = "Assistências"
    override val profileStatsChartsPerYear = "por ano"
    override val profileStatsChartsPerWeek = "por semana"
    override val profileStatsChartsPerMonth = "por mês"
    override fun profileStatsChartsTitle(stat: String, period: String) = "$stat $period"
    override val profileStatsChartsNoData = "Nenhum dado disponível"
    override val profileTeamEmptyOwnTitle = "Você ainda não tem um time"
    override val profileTeamEmptyOtherTitle = "Sem time"
    override val profileTeamEmptyCreateTeam = "Criar time"
    override val profileTrackerTitle = "Tracker"
    override val profileTrackerWorldMap = "Mapa-múndi"
    override val profileTeamMatchesEmpty = "Nenhuma partida ainda"
    override val profileTeamMatchesUpcomingTitle = "Próximas partidas"
    override val profileTeamMatchesUpcomingEmpty = "Nenhuma partida agendada"
    override val profileTeamMatchesVenueAlt = "Local"
    override fun profileTeamMatchesTeamsCount(count: Int) = "$count times"
    override fun profileTeamMatchesMembersCount(current: Int, total: Int) = "$current/$total membros"
    override fun profileTeamMatchesFormat(format: Int) = "Formato ${format}x${format}"
    override val profileTeamOverviewTitle = "Resumo do time"
    override val profileTeamOverviewClubTitle = "Clube de futebol"
    override val profileTeamOverviewRating = "Avaliação"
    override val profileTeamOverviewTeamRating = "Avaliação do time"
    override val profileTeamOverviewStatistics = "Estatísticas"
    override val profileTeamOverviewWins = "Vitórias"
    override val profileTeamOverviewDraws = "Empates"
    override val profileTeamOverviewLosses = "Derrotas"
    override val profileSidebarTitle = "Visão geral"
    override val profileSidebarFollowing = "Seguindo"
    override val profileSidebarFollowers = "Seguidores"
    override val profileSidebarAchievement = "Conquistas"
    override val profileSidebarAboutYouEmpty = "Adicione algumas palavras sobre você para apresentar seu perfil"
    override val profileSidebarFocusActivities = "Foco e atividades"
    override val profileSidebarSportLabel = "Esporte"
    override val profileSidebarActivityLabel = "Atividade"
    override val profileSidebarLifestyleLabel = "Estilo de vida"
    override val profileSidebarChat = "Chat"
    override val profileSidebarFollow = "Seguir"
    override val profileSidebarUnfollow = "Deixar de seguir"
    override val profileSidebarNoInterests = "Nenhum interesse adicionado"
    override val profileSidebarNoInterestsBody = "Mostre aos outros seus hobbies e esportes."
    override val profileHubTitle = "Central do jogador"
    override val profileHubYourStories = "Seus stories"
    override val profileHubStories = "Stories"
    override val profileHubCardShopUnavailable = "Loja de cards indisponível"
    override val profileHubCardShopTitle = "Loja de cards"
    override val profileHubCardShopSubtitle = "Compre novos cards. Defina seu estilo."
    override val profileHubActiveBought = "Ativos e comprados"
    override fun profileHubOwnedCount(count: Int) = "$count adquiridos"
    override val profileHubNoCardsYet = "Nenhum card ainda"
    override val profileHubAvailableForPurchase = "Disponíveis para compra"
    override val profileHubNewDesignsRegularly = "Novos designs regularmente"
    override val profileHubAllCardsOwned = "Você já tem todos os cards"
    override fun profileHubChartTitle(stat: String, period: String) = "$stat por $period"
    override val profileHubNoChartsTitle = "Nenhum gráfico disponível"
    override val profileHubNoChartsBody = "Escolha um esporte específico no cabeçalho para ver gols, assistências, jogos e o resto das suas estatísticas."
    override val profileHubContentTitle = "Conteúdo"
    override val profileHubLoading = "Carregando..."
    override val profileHubAddStory = "Adicionar story"
    override val profileHubAddPost = "Adicionar post"
    override val profileHubUserFallback = "usuário"
    override val profileHubNoPostsYet = "Nenhum post ainda"
    override val profileHubShareFirstMoment = "Compartilhe seu primeiro momento"
    override val profileHubPlayerNotPosted = "Este jogador ainda não postou."
    override val profileOverviewTitle = "Visão geral do jogador"
    override val profileOverviewPlayerIdentify = "Identidade do jogador"
    override val profileOverviewChat = "Chat"
    override val profileOverviewAiAvatar = "Avatar de IA"
    override val profileOverviewGoals = "Gols"
    override val profileOverviewGoalsUnit = "gols"
    override val profileOverviewWins = "Vitórias"
    override val profileOverviewWinsUnit = "vitórias"
    override val profileOverviewDraws = "Empates"
    override val profileOverviewDrawsUnit = "empates"
    override val profileOverviewLosses = "Derrotas"
    override val profileOverviewLossesUnit = "derrotas"
    override val profileOverviewAchievements = "Conquistas"
    override val profileOverviewNotFollowingAnyone = "Você ainda não segue ninguém"
    override val profileOverviewComingSoon = "Em breve"
    override val profileAwardsEmpty = "Ainda sem prémios"
    override val awardWelcomeTitle = "Prémio de boas-vindas"
    override val awardTermScorerFootball = "Melhor marcador"
    override val awardTermAssistFootball = "Melhor assistente"
    override val awardTermScorerBasketball = "Melhor pontuador"
    override val awardTermAssistBasketball = "Melhor assistente"
    override val awardTermScorerTennis = "Mais winners"
    override val awardTermAssistTennis = "Mais ases"
    override val awardTermScorerVolleyball = "Melhor atacante"
    override val awardTermAssistVolleyball = "Melhor assistente"
    override val awardTermScorerPadel = "Mais winners"
    override val awardTermAssistPadel = "Mais smashes"
    override val awardTermScorerGeneric = "Melhor marcador"
    override val awardTermAssistGeneric = "Melhor assistente"
    override val awardRank1 = "1.º lugar"
    override val awardRank2 = "2.º lugar"
    override val awardRank3 = "3.º lugar"
    override val profileOverviewAddPost = "Adicionar post"
    override val profileOverviewWritePlaceholder = "Escreva algo..."
    override val profileOverviewPost = "Publicar"
    override val profileOverviewLoading = "Carregando..."
    override val profileOverviewLoginToSeePosts = "Faça login para ver os posts"
    override val profileOverviewNoPostsYet = "Nenhum post ainda"
    override val profileWizardLetsGo = "Vamos lá!"
    override val profileWizardStepPersonalInfoTitle = "Dados pessoais"
    override val profileWizardStepPersonalInfoDescription = "Conte sobre você para começar."
    override val profileWizardStepFocusTitle = "Foco e atividades"
    override val profileWizardStepFocusDescription = "Escolha seus esportes e estilo de vida"
    override val profileWizardStepCardTitle = "Dê vida ao seu card"
    override val profileWizardStepCardDescription = "Crie sua identidade visual"
    override fun profileWizardSelectedCount(count: Int) = "$count selecionados"
    override val profileWizardPublicInfo = "Info pública"
    override val profileWizardMyStyles = "Meus estilos"
    override val profileWizardSelectToGenerate = "Selecione para gerar"
    override val profileWizardNoTemplates = "Nenhum modelo de card disponível ainda."
    override val profileWizardActiveCards = "Cards de perfil ativos"
    override val profileWizardDragToReorder = "Arraste para reordenar"
    override fun profileWizardCardCount(count: Int) = "$count card${if (count == 1) "" else "s"}"
    override val profileWizardCreatePhoto = "Criar foto"
    override val profileFocusEditTitle = "Foco e atividades"
    override val profileFocusEditDescription = "Escolha seus esportes e estilo de vida para definir sua identidade."
    override val profileFocusEditSelectedLabel = "selecionados"
    override val profileFocusEditClearAll = "Limpar tudo"
    override val profileFocusEditSearchPlaceholder = "Buscar atributos…"
    override val profileFocusEditSportLabel = "Esporte"
    override val profileFocusEditActivityLabel = "Atividade"
    override val profileFocusEditLifestyleLabel = "Estilo de vida"
    override val profileFocusEditNoMatches = "Nenhuma correspondência"
    override val profileFocusEditPreferenceDetails = "Detalhes de preferências"
    override val profileFocusEditPreferenceHint = "Opcional, mas ajuda você a encontrar pessoas com os mesmos interesses mais rápido."
    override val profileFocusEditNoteLabel = "Nota"
    override val profileFocusEditNotePlaceholder = "O que você está procurando?"
    override val profileFocusEditAddDetails = "Adicionar detalhes"
    override val profilePersonalEditTitle = "Dados pessoais"
    override val profilePersonalEditDescription = "Conte sobre você para começar."
    override val profilePersonalEditFirstNameLabel = "Nome"
    override val profilePersonalEditLastNameLabel = "Sobrenome"
    override val profilePersonalEditAboutMeLabel = "Sobre mim"
    override val profilePersonalEditBioPlaceholder = "Conte um pouco sobre você para outros jogadores…"
    override val profilePersonalEditDobLabel = "Data de nascimento"
    override val profilePersonalEditCityLabel = "Cidade"
    override val profilePersonalEditCitySearchPlaceholder = "Buscar cidade…"
    override val profilePersonalEditLanguagesLabel = "Idiomas"
    override val profilePersonalEditTypeLanguagePlaceholder = "Digite um idioma…"
    override val profilePersonalEditAddLanguagePlaceholder = "Adicionar idioma…"
    override val profileEditSheetPublicInfo = "Info pública"
    override val profileEditShellPublicInfo = "Info pública"
    override fun profileCreatePostAddAllPhotos(count: Int) = "Adicionar as $count foto(s)"
    override val profileCreatePostUploadFailed = "Falha no envio"
    override val profileCreatePostCreateFailed = "Falha ao criar o post"
    override val profileCreatePostTitle = "Criar post"
    override val profileCreatePostChooseLayout = "Escolha um layout"
    override val profileCreatePostFileTooLarge = "Arquivo muito grande (máx. 50 MB)"
    override val profileCreatePostCreating = "Criando..."
    override val profileCreatePostAddPhoto = "Adicionar foto"
    override val profileCreatePostContentLabel = "Conteúdo do post"
    override val profileCreatePostContentPlaceholder = "Escreva algo sobre este post..."
    override val profileCreatePostCityLabel = "Cidade"
    override val profileCreatePostCityPlaceholder = "Digite o nome da cidade..."
    override val profileCreateStoryPickPhotoFirst = "Escolha uma foto primeiro"
    override val profileCreateStoryUploadFailed = "Falha no envio"
    override val profileCreateStoryCreateFailed = "Falha ao criar o story"
    override val profileCreateStoryTitle = "Criar stories"
    override val profileCreateStorySubtitle = "Crie e compartilhe seus momentos"
    override val profileCreateStoryFileTooLarge = "Arquivo muito grande (máx. 30 MB)"
    override val profileCreateStoryCreating = "Criando..."
    override val profileCreateStoryDropHere = "Solte seu conteúdo aqui"
    override val profileCreateStoryMaxSize = " máx. 30 MB"
    override val profileFollowListFollowers = "Seguidores"
    override val profileFollowListFollowing = "Seguindo"
    override val profileFollowListNoResults = "Nenhum resultado"
    override val profileFollowListUnfollow = "Deixar de seguir"
    override val profileFollowListFollow = "Seguir"
    override val profileFollowListRemoved = "Removido"
    override val profileFollowListRemove = "Remover"
    override val profileFollowListNotFollowingTitle = "Você ainda não segue ninguém"
    override val profileFollowListNotFollowingBody = "Siga jogadores para ver os posts, melhores momentos e stories deles no seu feed."
    override val profileFollowListDiscoverPlayers = "Descobrir jogadores"
    override val profileFollowListNoFollowersTitle = "Nenhum seguidor ainda"
    override val profileFollowListNoFollowersBody = "Compartilhe seus posts e stories de partidas para ser notado pela comunidade."
    override val profileDialogPreferenceDetails = "Detalhes de preferências"
    override val profileStoryViewersTitle = "Quem viu este story?"
    override val profileStoryViewersNoViews = "Nenhuma visualização ainda"
    override val profileContentMobileOverview = "Visão geral"
    override val profileContentMobileFollowing = "Seguindo"
    override val profileContentMobileFollowers = "Seguidores"
    override val profileContentMobileAwardsComingSoon = "Prêmios em breve"
    override val profileContentMobileRecentEvents = "Eventos recentes"
    override val profileContentMobileNoEvents = "Nenhum evento agendado ainda"
    override val profileContentMobileNoEventsBody = "Escolha um evento e entre na ação!"
    override val profileContentMobileResultWin = "Vitória"
    override val profileContentMobileResultDraw = "Empate"
    override val profileContentMobileResultLoss = "Derrota"
    override val profileContentMobileSportFallback = "Esporte"
    override fun profileContentMobileFormat(format: Int) = "Formato $format X $format"
    override fun profileContentMobileMembers(count: Int) = "$count membros"
    override val profileContentMobilePlayerHub = "Central do jogador"
    override val profileContentMobileNoPostsTitle = "Nenhum post ainda"
    override val profileContentMobileNoPostsOwnBody = "Compartilhe fotos e melhores momentos das partidas para preencher seu perfil."
    override val profileContentMobileNoPostsOtherBody = "Este jogador ainda não postou nada."
    override val profileContentMobileCardsUnavailable = "Cards indisponíveis"
    override val profileContentMobileCardsLoadFailed = "Falha ao carregar os cards"
    override val profileContentMobileNoCardsAvailable = "Nenhum card disponível"
    override val profileContentMobileActiveBought = "Ativos e comprados"
    override fun profileContentMobileOwnedCount(count: Int) = "$count adquiridos"
    override val profileContentMobileAvailableForPurchase = "Disponíveis para compra"
    override val profileContentMobileNewDesigns = "Novos designs regularmente"
    override val profileContentMobileNoCardsYet = "Nenhum card ainda"
    override val profileContentMobileCardsTitle = "Cards"
    override val profileContentMobileAddPost = "Adicionar post"
    override val profileContentMobileUserFallback = "usuário"
    override val profileUserSheetError = "Algo deu errado"
    override val profileUserSheetThisUser = "este usuário"
    override fun profileUserSheetUnfollowTitle(name: String) = "Deixar de seguir $name?"
    override val profileUserSheetRefollowHint = "Você pode voltar a seguir quando quiser."
    override val profileUserSheetUnfollow = "Deixar de seguir"

    // header
    override val headerNavHome = "Início"
    override val headerNavAbout = "Sobre"
    override val headerNavServices = "Serviços"
    override val headerNavProjects = "Projetos"
    override val headerNavContacts = "Contatos"
    override val headerSportLabel = "Esporte:"
    override val headerUserFallbackName = "Usuário"
    override val headerNoActiveEvents = "Nenhum evento ou reserva ativa"
    override val headerNoNotifications = "Nenhuma notificação"
    override val headerYourActiveEvents = "Seus eventos ativos "
    override val headerNotificationsTitle = "Notificações "
    override val headerMarkAllRead = "Marcar tudo como lido"
    override val headerLoadMore = "Carregar mais"
    override val headerPendingApproval = "Aguardando aprovação"
    override val headerEventStatusNew = "Novo"
    override val headerEventStatusInProgress = "Em andamento"
    override val headerEventStatusCompleted = "Concluído"
    override val headerEventStatusCancelled = "Cancelado"
    override val headerBookingFallback = "Reserva"
    override val headerActionView = "Ver"
    override val headerActionReply = "Responder"
    override val headerActionUnfollow = "Deixar de seguir"
    override val headerActionFollowBack = "Seguir de volta"
    override val headerActionAccept = "Aceitar"
    override val headerActionDecline = "Recusar"
    override val headerConfirmTitle = "Tem certeza?"
    override val headerSignOutConfirmMessage = "Você vai sair da Arena neste dispositivo. Seus dados continuam seguros."
    override val headerSignOutConfirmLabel = "Sair"
    override val headerDeleteConfirmMessage = "Excluir seu perfil é permanente. Todos os créditos, momentos e estatísticas serão apagados."
    override val headerDeleteConfirmLabel = "Confirmar exclusão"
    override val headerDeleteProfileFailed = "Não foi possível excluir seu perfil. Tente novamente."
    override val headerUploading = "Enviando..."
    override val headerVisualStyle = "Estilo visual"
    override val headerSyncWithSportType = "Sincronizar com o esporte"
    override val headerMyWallet = "Minha carteira"
    override val headerSignOut = "Sair"
    override val headerSigningOut = "Saindo..."
    override val headerDeleteProfile = "Excluir perfil"
    override val headerRequestNoLongerAvailable = "Esta solicitação não está mais disponível."
    override val headerRequestProcessFailed = "Não foi possível processar a solicitação. Tente novamente."
    override val headerSelectClub = "Selecionar clube"
    override val headerAddClub = "Adicionar clube"
    override val headerSwitchToPlayer = "Mudar para jogador"
    override val headerLogout = "Sair"
    override val headerLoggingOut = "Saindo..."
    override val headerSigningIn = "Entrando..."

    // home
    override val homeHeroBrand = "Arena Pro Play"
    override val homeHeroUnites = "une"
    override val homeHeroAthletes = "atletas"
    override val homeHeroAndTeams = "e times"
    override val homeHeroWorldwideFor = "do mundo todo para"
    override val homeSectionCreateEventsTitle = "Crie eventos"
    override val homeSectionCreateEventsHighlight = "eventos"
    override val homeSectionCreateEventsSubtitle1 = "Escolha o esporte, defina o horário"
    override val homeSectionCreateEventsSubtitle2 = "e adicione o local do jogo."
    override val homeSectionTeammatesTitle = "Descubra parceiros perfeitos"
    override val homeSectionTeammatesHighlight = "parceiros"
    override val homeSectionMomentsTitle = "Compartilhe momentos, conecte-se com amigos"
    override val homeSectionMomentsHighlight = "amigos"
    override val homeSectionStatsTitle = "Acompanhe estatísticas, evolua seu progresso e personalize seu card"
    override val homeSectionStatsHighlight = "progresso"
    override val homeAltEventsScreen = "Tela de eventos"
    override val homeAltCreateEventScreen = "Tela de criação de evento"
    override val homeAltCreateEventModal = "Modal de criação de evento"
    override val homeAltEventDetailScreen = "Tela de detalhes do evento"
    override val homeAltDiscoverPeople = "Descobrir pessoas"
    override val homeAltPlayerDiscoveryCard = "Card de descoberta de jogador"
    override val homeAltMatchedInterests = "Interesses em comum"
    override val homeAltMatchedInterestsModal = "Modal de interesses em comum"
    override val homeAltItsAMatch = "Deu match"
    override val homeAltFeedScreen = "Tela do feed"
    override val homeAltFeedPost = "Post do feed"
    override val homeAltGameMomentsPost = "Post de momentos do jogo"
    override val homeAltChatScreen = "Tela do chat"
    override val homeAltProfileOverview = "Visão geral do perfil"
    override val homeAltProfileDashboard = "Painel do perfil"
    override val homeAltPlayerStatsRadar = "Radar de estatísticas do jogador"
    override val homeAltPlayerStatsCard = "Card de estatísticas do jogador"
    override val homeAltRatePerformance = "Avaliar desempenho"
    override val homeAltRatePerformanceModal = "Modal de avaliar desempenho"
    override val homeItsYourMatch = "Deu match para você!"
    override val homeLabelGameMoments = "Momentos do jogo"
    override val homeLabelPlayerStats = "Estatísticas do jogador"
    override val homeLabelRatePerformance = "Avaliar desempenho"
    override val homeFooterTagline = "Sua comunidade esportiva global"
    override val homeFooterBlurb = "Encontre pessoas perto de você para jogar futebol, tênis, basquete, padel ou vôlei — participe de jogos casuais e eventos esportivos locais, ou crie o seu na Arena."
    override val homeFooterAbout = "Sobre"
    override val homeFooterTerms = "Termos de serviço"
    override val homeFooterPrivacy = "Política de privacidade"
    override val homeFooterPricing = "Preços"
    override val homeFooterRefund = "Política de reembolso"
    override val homeFooterSupports = "Suporte"
    override val homeFooterCopyright = "© 2026 Arena Pro Play"
    override val homeStoreAppleEyebrow = "BAIXE NA"
    override val homeStoreAppleName = "Apple Store"
    override val homeStoreGoogleEyebrow = "DISPONÍVEL NO"
    override val homeStoreGoogleName = "Google Play"

    // dashboard
    override val dashboardTabAnalytics = "Análises"
    override val dashboardTabSchedule = "Agenda"
    override val dashboardRatingTitle = "Avaliação"
    override val dashboardReviews = "avaliações"
    override val dashboardAvgDuration = "Duração média"
    override val dashboardTotalRevenue = "Receita total"
    override val dashboardTotalBookings = "Total de reservas"
    override val dashboardArenaSchedule = "Agenda da arena"
    override val dashboardThisWeek = "Esta semana"
    override val dashboardAddEvent = "Adicionar evento"
    override val dashboardTimeHeader = "Horário"
    override val dashboardCustomerFallback = "Cliente"
    override val dashboardRevenueTitle = "Receita"
    override val dashboardBookingsTitle = "Reservas"
    override val dashboardBookingStatusTitle = "Status das reservas"
    override val dashboardBookingHeatmapTitle = "Mapa de calor das reservas"
    override val dashboardDonutTotal = "Total"
    override val dashboardBookingsTooltipPrefix = "Reservas "
    override val dashboardStatusConfirmed = "Confirmadas"
    override val dashboardStatusCompleted = "Concluídas"
    override val dashboardStatusPending = "Pendentes"
    override val dashboardStatusUnpaid = "Não pagas"
    override val dashboardStatusDeclined = "Recusadas"
    override val dashboardNoData = "Sem dados"
    override val dashboardDayMon = "Seg"
    override val dashboardDayTue = "Ter"
    override val dashboardDayWed = "Qua"
    override val dashboardDayThu = "Qui"
    override val dashboardDayFri = "Sex"
    override val dashboardDaySat = "Sáb"
    override val dashboardDaySun = "Dom"
    override fun dashboardHourLabel(hour: Int) = "${hour}h"
    override fun dashboardHeatmapTooltip(day: String, fromHour: Int, toHour: Int, count: Int) = "$day $fromHour:00–$toHour:00 · $count reservas"

    // arena
    override val arenaActionViewResults = "Ver resultados"
    override val arenaActionWatchLive = "Assistir ao vivo"
    override val arenaActionJoinNow = "Entre agora"
    override val arenaStatusLive = "Live"
    override val arenaStatusNew = "Novo"
    override val arenaStatusCompleted = "Concluído"
    override val arenaStatusCanceled = "Cancelado"
    override fun arenaMembersJoinedTotal(joined: Int, total: Int) = "$joined / $total membros"
    override fun arenaMembersCount(count: Int) = "$count membros"
    override fun arenaTeamsCount(count: Int) = "$count times"
    override fun arenaFormat(format: String) = "Formato $format"
    override fun arenaFinalScore(score: String) = "Placar final $score"
    override fun arenaDuration(duration: String) = "Duração $duration"
    override val arenaLoadingClubs = "Carregando clubes..."
    override val arenaLoadingMoreEvents = "Carregando mais eventos..."
    override val arenaLoadingMoreClubs = "Carregando mais clubes..."
    override val arenaLocationLabel = "Local: "
    override val arenaAllCities = "Todas as cidades"
    override val arenaCommunityAll = "Todas"
    override val arenaCommunityUnnamed = "Sem nome"
    override val arenaTabClubs = "Clubes"
    override val arenaTabEvents = "Eventos"
    override val arenaEmptyTitle = "Nenhum evento agendado ainda"
    override val arenaEmptySubtitle = "Crie um evento com chat da partida e acompanhamento em tempo real."
    override val arenaAddEvent = "Adicionar evento"
    override val arenaNoClubsTitle = "Nenhum clube ainda"
    override val arenaNoClubsSubtitle = "Os clubes vão aparecer aqui"

    // people
    override val peopleErrorLoad = "Não foi possível carregar as pessoas"
    override val peopleCaughtUpTitle = "Você está em dia"
    override val peopleCaughtUpSubtitle = "Volte mais tarde para ver mais jogadores."
    override val peopleRefresh = "Atualizar"
    override val peopleBadgeLike = "LIKE"
    override val peopleBadgeNope = "NOPE"
    override fun peopleNameAge(name: String, age: Int) = "$name, $age"

    // feed
    override val feedEmptyTitle = "Seu feed está vazio"
    override val feedEmptySubtitle = "Siga jogadores para ver os posts e stories deles aqui."
    override val feedNoCommentsTitle = "Nenhum comentário ainda"
    override val feedNoCommentsSubtitle = "Seja o primeiro a comentar."
    override val feedMessagePlaceholder = "Digite uma mensagem..."
    override val feedLikeZero = "Curtir"
    override val feedLikeOne = "1 curtida"
    override fun feedLikeMany(count: Int) = "$count curtidas"

    // auth
    override val authWelcomeTitle = "Bem-vindo à Arena!"
    override val authWelcomeSubtitle = "Faça login com Google ou Apple para criar seu perfil, desbloquear esta página e começar sua jornada esportiva com a gente."
    override val authAgreePrefix = "Ao continuar, você concorda com nossos"
    override val authTerms = "Termos"
    override val authPrivacy = "Privacidade"

    // layout
    override val layoutComingSoon = "Em breve"
}
